export const ERROR_CODES = [
  'INVALID_PAYLOAD',
  'ROOM_NOT_FOUND',
  'ROOM_CLOSED',
  'FORBIDDEN',
  'INVALID_PHASE',
  'JOIN_CLOSED',
  'ROOM_FULL',
  'NAME_INVALID',
  'NAME_TAKEN',
  'NOT_A_PLAYER',
  'ADMIN_NOT_PLAYING',
  'ADMIN_ALREADY_JOINED',
  'NOT_ELIGIBLE',
  'ALREADY_VOTED',
  'STALE_SESSION',
  'PLAYER_NOT_FOUND',
  'SAME_PLAYER',
  'NO_ELIGIBLE_VOTERS',
  'ALREADY_ALIVE',
  'ALREADY_DEAD',
  'AVATAR_TOO_LARGE',
  'AVATAR_INVALID',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

/** Thrown by the pure domain layer; translated to a wire error by the gateway. */
export class DomainError extends Error {
  constructor(
    public readonly code: ErrorCode,
    message?: string,
  ) {
    super(message ?? code);
    this.name = 'DomainError';
  }
}

export function isDomainError(e: unknown): e is DomainError {
  return e instanceof DomainError;
}
